import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IFaqGroupItemDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-faq-item-viewer',
  templateUrl: './faq-item-viewer.component.html',
  styleUrls: ['./faq-item-viewer.component.css']
})
export class FaqItemViewerComponent implements OnInit {
  @Input() item: IFaqGroupItemDto;
  timestamp = new Date().getTime();
  safeYouTubeUrl: SafeResourceUrl | null = null;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    if (this.item && this.item.videoLink && this.isYouTubeLink(this.item.videoLink)) {
      this.safeYouTubeUrl = this.getYouTubeEmbedUrl(this.item.videoLink);
    }
  }

  isYouTubeLink(url: string): boolean {
    if (!url) return false;
    return url.includes('youtube.com') || url.includes('youtu.be');
  }

  private getYouTubeEmbedUrl(url: string): SafeResourceUrl {
    let videoId = '';
    try {
      if (url.includes('youtube.com/watch?v=')) {
        videoId = url.split('v=')[1].split('&')[0];
      } else if (url.includes('youtu.be/')) {
        videoId = url.split('youtu.be/')[1].split('?')[0];
      } else if (url.includes('youtube.com/embed/')) {
        videoId = url.split('embed/')[1].split('?')[0];
      }
    } catch (e) {
      console.error('Error parsing YouTube URL:', url, e);
    }
    
    // Remove autoplay=1 as requested.
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`);
  }
}

